
import { Component, Vue } from 'vue-property-decorator'
import RedirectToKionButton from '../RedirectToKionButton.vue'
import {gtm} from "@/util/GTMService";
import { getClientID } from '@/util/helpers';
import { httpService } from '@/util/HttpAdapter';

const itemsData = [
  {
    icon: 'img/subscription/sub1.png',
    text: 'Доставка заказов курьером без доплат',
  },
  {
    icon: 'img/subscription/sub2.png',
    text: 'Кешбэк 5% за рестораны и фастфуд по карте Ozon Банка',
    class: 'long',
  },
  {
    icon: 'img/subscription/sub3.png',
    text: 'Бесплатный возврат заказов курьером',
  },
  {
    icon: 'img/subscription/sub4.png',
    text: 'Скидка на доставку из Ozon Fresh',
  },
]

@Component({ components: { RedirectToKionButton } })
export default class KionOzonSwitchBlock extends Vue {
  private items = itemsData

  async mounted() {
	const { huaweiSubscriberId } = (await httpService.getUserId()).data
	httpService.grclientid = huaweiSubscriberId

	const intervalId = setInterval(() => {
		if (getClientID()) {
		clearInterval(intervalId)
		gtm.pushEvent({
			event_name: 'screen_show'
		})
		}
	}, 500)
  }
}
